// =====================================================
// 📁 QuotationHistoryEmpty.tsx
// =====================================================

import { History } from 'lucide-react';

const QuotationHistoryEmpty = () => {
  return (
    <div
      className="
        flex
        flex-col
        items-center
        justify-center

        rounded-2xl

        border
        border-dashed
        border-stroke

        bg-gray/30

        px-6
        py-14

        text-center

        dark:border-strokedark
        dark:bg-boxdark-2
      "
    >
      {/* ===================================================== */}
      {/* 🔹 Icon */}
      {/* ===================================================== */}

      <div
        className="
          flex
          h-16
          w-16
          items-center
          justify-center

          rounded-2xl

          border
          border-primary/10

          bg-primary/5

          text-primary
        "
      >
        <History size={30} />
      </div>

      {/* ===================================================== */}
      {/* 🔹 Content */}
      {/* ===================================================== */}

      <h3
        className="
          mt-5

          text-base
          font-semibold

          text-black

          dark:text-white
        "
      >
        No hay historial de cotizaciones
      </h3>

      <p
        className="
          mt-2
          max-w-[320px]

          text-sm
          leading-relaxed

          text-body
        "
      >
        Las cotizaciones activas y expiradas aparecerán aquí para que puedas
        consultarlas o procesarlas posteriormente.
      </p>
    </div>
  );
};

export default QuotationHistoryEmpty;
